<template>
	<div>
		<div class="page-bg page-bg-album">
			<div class="flex1 f-pr">
				<!-- <iframe style="width: 100%; height: 100%;position: absolute;left: 0;top: 0;border: none;" src="https://alltuu.cc/r/a6NzQv/"></iframe> -->
				<iframe style="width: 100%; height: 100%;position: absolute;left: 0;top: 0;border: none;" src="https://alltuu.cc/album/52e52d087cfcaaa24ea97ff7cedb0e07/?menu=live"></iframe>
			</div>
			<div>
				<i-nav></i-nav>
			</div>
		</div>




	</div>
</template>

<script>


export default {

	data() {
		return {
			uid: null


		};
	},
	async mounted() {
		this.uid = window.localStorage.getItem('cscec2026UserId')
		if (!this.uid) {
			this.$router.push({ path: '/' })
			return
		}


	},
	methods: {


	},
};
</script>
<style scoped lang="less">
.page-bg-album{
	
	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	// position: absolute;
	// bottom: 170px;
	// width: 100%;
	// top: 146px;
	// overflow: hidden;
	// overflow-y: auto;

	.flex1{
		flex:1
	}
	.f-pr{
		position: relative;
	}
	img {
		display: block;
		width: 100%;
	}
}
</style>
